function checkIfDivExistsInsideElement(elements, className) {
        // Get the children of the current element
        var children = elements.children;
        // Loop through the children of the current element
        for (var j = 0; j < children.length; j++) {
            // Check if the current child is a <div> element and has the specified class
            if (children[j].classList.contains(className)) {
                return true; // Return true if found
            }
        }
    // Return false if not found after checking all elements
    return false;
}

// let mediaQuery = window.innerWidth;
// window.addEventListener("resize", function(){
//   console.log(window.innerWidth);
//    mediaQuery = window.innerWidth;
// });
// let mediaQuery = window.matchMedia("(max-width: 768px)")
let parentContainer = document.getElementById("MainContent");
let footerContainer = document.getElementsByClassName("shopify-section-group-footer-group");
let verticalSections = document.getElementsByClassName("riff-custom-vertical");
let sections = document.getElementsByTagName("section");


    if(verticalSections.length > 0){
      parentContainer.style.position = "relative";
      footerContainer[0].style.position = "relative";
        for (let section of sections) {
          let mediaQuery = window.innerWidth;
          window.addEventListener("resize", function(){
            // console.log(window.innerWidth);
             mediaQuery = window.innerWidth;
            if(!checkIfDivExistsInsideElement(section, 'riff-custom-vertical') && mediaQuery > 768){
            section.style.width = "60%";
            section.style.margin = "auto";
          }else{
            section.style.width = "100%";
          }
          });
          if(!checkIfDivExistsInsideElement(section, 'riff-custom-vertical') && mediaQuery > 768){
            section.style.width = "60%";
            section.style.margin = "auto";
          }else{
            section.style.width = "100%";
          }
        }
    }

// Lightbox 

document.addEventListener('DOMContentLoaded', function () {
    const lightbox = document.getElementById('lightbox');
    const lightboxImg = document.getElementById('lightbox-img');
    const closeBtn = document.getElementById('close-btn');
    const triggers = document.querySelectorAll('.lightbox-trigger');

    triggers.forEach(trigger => {
     
        trigger.addEventListener('click', function () {
           // console.log("triggered")
            const imgSrc = this.getAttribute('src');
            lightboxImg.setAttribute('src', imgSrc);
            lightbox.style.display = 'flex';
        });
    });
    if(closeBtn){
      closeBtn.addEventListener('click', function () {
          lightbox.style.display = 'none';
      });
    }
});

// document.addEventListener('DOMContentLoaded', function () {

  
//   // let grid_images = Array.from(document.getElementsByClassName('grid-image'))
//   // let chunks = [];
//   // let chunkSize = 6;

  
  
//   // console.log(chunks);
//   console.log(document.getElementsByClassName('grid-image'))
 

// // Create Load More Button
// const loadMoreButton = document.createElement('button');
// loadMoreButton.textContent = "Load More";
// loadMoreButton.addEventListener('click', () => {
//     currentChunkIndex++;
//     displayChunk(currentChunkIndex);
//     if (currentChunkIndex >= itemChunks.length - 1) {
//         loadMoreButton.style.display = 'none';
//     }
// });
// document.body.appendChild(loadMoreButton);
  
// })
   const hideImage = document.getElementsByClassName("grid-image");
  const itemsPerPage = 15;
  let currentPage = 1;
let filteredImages = [];
  

function showMore(){
  
    const start = itemsPerPage * currentPage;
    const end = itemsPerPage * (currentPage + 1);
      // console.log(itemsPerPage)
    // console.log(filteredImages)
  if(filteredImages.length > 0){
    for (let i = start; i < end && i < hideImage.length; i++) {
      
        filteredImages[i].style.display = 'inline-block';
        if(i+1 === filteredImages.length){
          document.getElementById("load-artists").style.display = "none";
        }
      }
      currentPage++;
      // console.log(filteredImages)
      if (start >= filteredImages.length) {
        document.getElementById('load-artists').style.display = 'none';
      }
  }
  }

function containsClass(className, GridImage) {
  // Iterate through the elements and check if any of them contain the specified class
    return GridImage.classList.contains(className);
}

 function dayFilter(day){
   currentPage = 0;
   document.getElementById("load-artists").style.display = 'inline';
   let GridImages =  document.getElementsByClassName("grid-image");
   filteredImages = [];
  // console.log(GridImages)
  for (let i = 0; i < GridImages.length; i++) {
    if (day === "full" || containsClass(day, GridImages[i])) {
      GridImages[i].style.display = "none";
      filteredImages.push(GridImages[i]);
      
    } else {
      GridImages[i].style.display = "none";
    }
  }

  
  // document.getElementById('show-more-btn').style.display = 'inline-block';
  showMore(); // Show the first set of filtered items
   
}



setTimeout(()=>{
  let GridImages =  document.getElementsByClassName("grid-image");
  if(GridImages.length > 0){
    dayFilter("full")
  }
}, 3000)
// document.addEventListener('DOMContentLoaded', function (event) {
//   let GridImages =  document.getElementsByClassName("grid-image");
//   if(GridImages.length > 0){
//     dayFilter("full")
//   }
// })
// document.addEventListener('DOMContentLoaded', function (event) {
//   document.getElementById('artistFilterInput').addEventListener('change', function(event) {
//       artistFilter(event);
//   });
// })
function artistFilter(e){

    // Get all items that you want to filter
    const filterValue = event.target.value.replace(/\s+/g, '').toLowerCase();
    const items = document.querySelectorAll('.grid-image');
    let count = 0;

    items.forEach(item => {
      const artistName = item.dataset.artistName;
      if (filterValue === "") {
        dayFilter('full')
      }
      if (artistName.includes(filterValue)) {
        item.style.display = 'block';
        count++;  // Increment the count when filterValue is found in artistName
      } else {
        item.style.display = 'none';
      }
    });
  if(count < 15){
    document.getElementById('load-artists').style.display = 'none';
  }else{
    document.getElementById('load-artists').style.display = 'contents';
  }
}
// Flip the image and post to GA 
function clickFlip(url,elem){
  let mc = document.querySelector(`[data-target=${url}]`);
  mc.classList.add("animate");
  flipBack(mc);
  gtag('event', 'button_click', {
    'event_category': 'sponsor-reveal',
    'event_label': url
  });
}

function flipBack(mc){
  setTimeout(()=>{
    mc.classList.remove("animate");
    animate
}, 6000)
}